import Clock from "./Clock";
import { FormattedMessage } from "react-intl";
import { LocalizationMessages } from "../localization/messages";
import PropTypes from "prop-types";
import React from "react";
import SessionTime from "./SessionTime";
import { UserContextSelectors } from "../redux/selectors";
import parseISO from "date-fns/parseISO";
import { useSelector } from "react-redux";
import { Brand } from "../configurations";

const setLastLogin = lastLoginDateTime => {
  if (!lastLoginDateTime) return "";

  return parseISO(lastLoginDateTime).toLocaleString();
};

const LastLogin = ({ includeSessionTime }) => {
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const lastLogin = useSelector(UserContextSelectors.lastLogin);
  const brandId = useSelector(UserContextSelectors.brandId);
  const isMobile = useSelector(UserContextSelectors.isMobile);

  return (
    <div className="aClastLoginWrapper">
      <Clock
        isIconVisible={
          (brandId === Brand.Sport_MG_SE ||
            brandId === Brand.Sport_MG_DK ||
            brandId === Brand.Sport_MG_MGA) &&
          isMobile
        }
      />
      {isAuthenticated && (
        <div className="aClastLogin">
          <p className="aClastLoginTitle">
            <FormattedMessage {...LocalizationMessages.lastLogin} />{" "}
          </p>
          <p>{setLastLogin(lastLogin)}</p>
          {includeSessionTime && <SessionTime />}
        </div>
      )}
      <div className="clear" />
    </div>
  );
};

LastLogin.propTypes = {
  includeSessionTime: PropTypes.bool
};

LastLogin.defaultProps = {
  includeSessionTime: true
};

export default React.memo(LastLogin);
